

































































import { AccountApi } from "@/api";
import stateMixin from "@/mixins/state";
import isPassword from "@/util/validators/password";

export default {
  data() {
    return {
      valid: true,
      fields: {
        currentPassword: "",
        newPassword: "",
        passwordRepeat: ""
      },
      rules: {
        currentPassword: [v => !!v || "Huidig wachtwoord is verplicht"],
        newPassword: [
          v => !!v || "Nieuw wachtwoord is verplicht",
          v =>
            isPassword(v) ||
            "Wachtwoord voldoet niet aan de vereisten: 8 karakters, 1 hoofdletter, 1 kleine letter en 1 cijfer"
        ],
        passwordRepeat: [v => !!v || "Herhaal nieuw wachtwoord is verplicht"]
      }
    };
  },
  name: "SettingsSecurity",
  mixins: [stateMixin],
  methods: {
    submit: async function() {
      if (this.valid) {
        this.setState(this.states.LOADING);
        const api = new AccountApi();
        try {
          const result = await api.accountUpdatePassword(this.fields);
          this.setState(this.states.COMPLETED);
          (this.$refs.form as HTMLFormElement).reset();
        } catch {
          this.setState(this.states.ERROR);
        }
      }
    }
  }
};
